import { gql } from "@apollo/client";

export const LEAD_TYPOLOGIES = gql`
  query LeadTypologies(
    $where: LeadTypologyWhereInput
    $take: Int
    $skip: Int
    $like: LeadTypologyWhereInput
  ) {
    leadTypologies(where: $where, take: $take, skip: $skip, like: $like) {
      data {
        id
        label
      }
      count
    }
  }
`;

const leadTypologies = { LEAD_TYPOLOGIES };

export default leadTypologies;
